module.exports = __webpack_public_path__ + "catalog/items/livingroom/Chairs/Chairs.svg";